import { render, staticRenderFns } from "./SettingCmp.vue?vue&type=template&id=6cb72231&scoped=true"
import script from "./SettingCmp.vue?vue&type=script&lang=js"
export * from "./SettingCmp.vue?vue&type=script&lang=js"
import style0 from "./SettingCmp.vue?vue&type=style&index=0&id=6cb72231&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb72231",
  null
  
)

export default component.exports